import BioPage from './components/BioPage';

function App() {
  return (
    <div>
      <BioPage />
    </div>
  );
}

export default App;
